import ContentfulPreOrderModal from '@src/quince-site-common/src/domains/contentful/ContentfulPreOrder'

import PreOrderMessage from '../preOrderMessage/PreOrderMessage'
import { VariantPurchaseInfo } from '../productForm/ProductForm'

import { CTA_TYPE } from './productCTAConstants'

interface ProductMessageType {
  type: any
  selectedVariantPurchaseInfo?: VariantPurchaseInfo | undefined
  preOrderModalData?: ContentfulPreOrderModal | undefined
  customMessage?: string
}

function ProductMessage({
  type,
  selectedVariantPurchaseInfo,
  preOrderModalData,
  customMessage = undefined,
}: ProductMessageType) {
  if (type !== CTA_TYPE.PREORDER) {
    return null
  }

  return (
    <PreOrderMessage
      selectedVariantId={selectedVariantPurchaseInfo?.selectedVariantId}
      preOrderModalData={preOrderModalData}
      preOrderShippingDate={selectedVariantPurchaseInfo?.preOrderShippingDate}
      customMessage={customMessage}
    />
  )
}

export default ProductMessage
